"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.goToLodgeDetails = goToLodgeDetails;
exports.goToTrekOverview = goToTrekOverview;
exports.goToProfile = goToProfile;
exports.goToGuideProfile = goToGuideProfile;
exports["default"] = void 0;

var _slugify = _interopRequireDefault(require("@sindresorhus/slugify"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var resolveRegion = function resolveRegion(region) {
  return region ? ".".concat((0, _slugify["default"])(region), "-region") : '';
};

function goToLodgeDetails(lodgeName, lodgeId, placeName) {
  return "/".concat((0, _slugify["default"])(lodgeName), ".").concat(lodgeId, ".").concat((0, _slugify["default"])(placeName), "-lodges");
}

function goToTrekOverview(name, id, region) {
  return "/treks/".concat((0, _slugify["default"])(name), ".").concat(id).concat(resolveRegion(region));
}

function goToProfile(name, id) {
  return "/".concat(name ? (0, _slugify["default"])(name) : 'newtrekker', ".").concat(id);
}

function goToGuideProfile(name, id) {
  return "/guides/".concat(name ? (0, _slugify["default"])(name) : 'newtrekker', ".").concat(id);
}

var goToFlight = '/flights/all';
var goToLodge = '/lodges';
var goToExplore = '/explore';
var goToTreks = '/treks';
var goToGuideListings = '/guides';
var goToTransportation = '/transportation';
var goToBlog = '/blog';
var _default = {
  goToProfile: goToProfile,
  goToTrekOverview: goToTrekOverview,
  goToLodgeDetails: goToLodgeDetails,
  goToFlight: goToFlight,
  goToLodge: goToLodge,
  goToExplore: goToExplore,
  goToTreks: goToTreks,
  goToGuideListings: goToGuideListings,
  goToGuideProfile: goToGuideProfile,
  goToTransportation: goToTransportation,
  goToBlog: goToBlog
};
exports["default"] = _default;